/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card,
    Autocomplete
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { truncate } from 'lodash';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function MarketPriceListing() {
    const screenCode = 'MARKETPRICE';
    let encrypted = "";
    const navigate = useNavigate();
    const [productcatogery, setProductcatogery] = useState([]);
    const [selectedProductOption, setSelectedProductOption] = useState(0);
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [selectedProductCategory, setSelectedProductCategory] = useState(0);
    const [IsClear, setIsClear] = useState(false);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [product, setProduct] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        groupID: "0",
        productCategoryID: '',
        productID: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.number().min(1, 'Please Select Product').required('Product Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            productCategoryID: selectedProductCategory.productCategoryID,
            productID: formData.productID,
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetProductPricesByFilter(values));
            
        },
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        GetAllGroups();
        trackPromise(GetProductCategoties());
    }, []);

    useEffect(() => {
        setProduct([]);
        setTableData([]);
        formik.setFieldValue('productID', '');
        formik.setFieldValue('productCategoryID', '');
        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: '',
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProductOption(0)
        setSelectedProductCategory(0)
    }, [formik.values.groupID]);
    
    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        formik.setFieldValue('productID', '');
        setAutocompleteKey((prevKey) => prevKey + 1);
        setValues({
            ...values,
            productCategoryID: selectedProductCategory,
            productID: ''
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
        setSelectedProductOption(0)
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setValues({
            ...values,
            productID: selectedProductOption
        });
        setIsFarmerClear(!isFarmerClear);
        setTableData([]);
    }, [formik.values.productID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'MARKETPRICE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetProductCategoties());
    }

    async function GetAllGroups() {
        var resNew = await services.GetAllGroupsForMarketScreen();
        if (resNew != null) {
            setGroupList(resNew);
        }
    }

    async function GetProductPricesByFilter() {
        var res = await services.GetMarketPricesForMarketPriceScreen(values);
        if (res != null) {
            setTableData(res);
        }
        setPage(0);
    }

    function clearAll() {
        setValues({
            ...values,
            productCategoryID: '',
            productID: ''
        })
        setIsClear(!IsClear);
        setAutocompleteKey((prevKey) => prevKey + 1);
        formik.resetForm();
        setTableData([])

    }

    async function handleClick(datas) {
        encrypted = await AESEncryptionParam(datas.toString());
        navigate('/dashboard/viewSellingPrice/addedit/' + encrypted)
    }

    async function GetProductCategoties() {
        var result = await services.GetProductCategoties()
        result.forEach(x => {
            x.productCategoryName = x.productCategoryName == null || x.productCategoryName == "" ? x.categoryCode : x.productCategoryName
        })
        setProductcatogery(result);

    }

    async function GetProductDetails() { 
        var res = await services.GetProductDetailsByProductcatogeryID(formik.values.productCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setSelectedCategory(data);
            setValues({
               ...formik.values,
                productCategoryID: '0'
            });
            return;
        } else {
            setSelectedCategory(data);
            var nameP = 'productCategoryID';
            var valueP = data.productCategoryID;
            setValues({
                ...formik.values,
                productCategoryID: valueP
            });
            setSelectedProductCategory(valueP);
        }
    }

    function handleSearchCrop(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...formik.values,
                productID: 0, 
            });
        } else {
            setValues({
                ...formik.values,
                productID: data.productID, 
            });
            setSelectedProductOption(data.productID);
        }
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.productCategoryName && option.productCategoryName.toLowerCase().includes(trimmedInput)) 
        ).filter(option => option.productCategoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.productCategoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Selling Price |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewSellingPrice/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Selling Price"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack spacing={2}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                fullWidth
                                                key={IsClear}
                                                id="productCategoryID"
                                                options={productcatogery}
                                                filterOptions={filterOptions}
                                                getOptionLabel={(option) => option.productCategoryName || ''}
                                                onChange={(e, value) => {
                                                    handleSearchDropdownChangePrefferdName(value, e);
                                                    formik.setFieldValue('productID', '');
                                                }}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="productCategoryID"
                                                        label="Product Category *"
                                                        size="small"
                                                        fullWidth
                                                        value={formik.values.productCategoryID}
                                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                                    />
                                                }
                                            /> 
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <Autocomplete
                                                fullWidth
                                                key={autocompleteKey}
                                                id="productID"
                                                options={product}
                                                getOptionLabel={(option) => option.productName || ''}
                                                onChange={(e, value) => handleSearchCrop(value, e)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        name="productID"
                                                        label="Product *"
                                                        size="small"
                                                        fullWidth
                                                        value={formik.values.productID}
                                                        helperText={touched.productID && errors.productID}
                                                        error={Boolean(touched.productID && errors.productID)}
                                                    />
                                                )}
                                            />
                                        </Grid>                                     
                                    </Stack>
                                    <Grid >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Selling Price" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <><TableCell align="left">Date</TableCell></>
                                                <TableCell align="left">Product Category</TableCell>
                                                <TableCell align="left">Product Name</TableCell>
                                                <TableCell align="right">Selling Price</TableCell>
                                                <TableCell align="right">Proposed Price</TableCell>
                                                <TableCell align="right">Competitor Price</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.productPriceID}>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {new Date(row.sellingDate).toISOString().split('T')[0]}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.productCategoryName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.sellingPrice == null || row.sellingPrice == 0 ? "-": parseFloat(row.sellingPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.proposedPrice == null || row.proposedPrice == 0 ? "-": parseFloat(row.proposedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.competitorPrice == null || row.competitorPrice == 0 ? "-": parseFloat(row.competitorPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row.productPriceID)}  >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}